import { useTranslation } from "react-i18next";
import { appConfig } from "~/src/appConfig";
import BottomLine from "~/src/components/BottomLine";
import ExternalLink from "~/src/components/Links/ExternalLink";
import InternalLink from "~/src/components/Links/InternalLink";

const HjelpOgKontakt = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <div className="pt-6 mx-4 pb-4">
      <ul>
        <InternalLink
          path="/minside/om"
          text={t("pages.hjelpOgKontakt.omSos")}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              role="graphics-symbol"
            >
              <path
                d="M10.8 18H13.2V10.8H10.8V18ZM12 8.4C12.34 8.4 12.625 8.285 12.855 8.055C13.085 7.825 13.2 7.54 13.2 7.2C13.2 6.86 13.085 6.575 12.855 6.345C12.625 6.115 12.34 6 12 6C11.66 6 11.375 6.115 11.145 6.345C10.915 6.575 10.8 6.86 10.8 7.2C10.8 7.54 10.915 7.825 11.145 8.055C11.375 8.285 11.66 8.4 12 8.4ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24ZM12 21.6C14.68 21.6 16.95 20.67 18.81 18.81C20.67 16.95 21.6 14.68 21.6 12C21.6 9.32 20.67 7.05 18.81 5.19C16.95 3.33 14.68 2.4 12 2.4C9.32 2.4 7.05 3.33 5.19 5.19C3.33 7.05 2.4 9.32 2.4 12C2.4 14.68 3.33 16.95 5.19 18.81C7.05 20.67 9.32 21.6 12 21.6Z"
                fill="#37261D"
              />
            </svg>
          }
        />
        <InternalLink
          bottomLine
          path="/minside/kontakt"
          text={t("pages.minSide.lenker.kontaktinformasjon")}
          icon={
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="24"
              viewBox="0 0 20 24"
              fill="none"
              role="graphics-symbol"
            >
              <path
                d="M10.5882 24L10.2941 20.4H10C7.21569 20.4 4.85294 19.41 2.91176 17.43C0.970588 15.45 0 13.04 0 10.2C0 7.36 0.970588 4.95 2.91176 2.97C4.85294 0.99 7.21569 0 10 0C11.3922 0 12.6912 0.265 13.8971 0.795C15.1029 1.325 16.1618 2.055 17.0735 2.985C17.9853 3.915 18.701 4.995 19.2206 6.225C19.7402 7.455 20 8.78 20 10.2C20 11.7 19.7598 13.14 19.2794 14.52C18.799 15.9 18.1422 17.18 17.3088 18.36C16.4755 19.54 15.4853 20.61 14.3382 21.57C13.1912 22.53 11.9412 23.34 10.5882 24ZM12.9412 19.62C14.3333 18.42 15.4657 17.015 16.3382 15.405C17.2108 13.795 17.6471 12.06 17.6471 10.2C17.6471 8.02 16.9069 6.175 15.4265 4.665C13.9461 3.155 12.1373 2.4 10 2.4C7.86275 2.4 6.05392 3.155 4.57353 4.665C3.09314 6.175 2.35294 8.02 2.35294 10.2C2.35294 12.38 3.09314 14.225 4.57353 15.735C6.05392 17.245 7.86275 18 10 18H12.9412V19.62ZM9.97059 16.77C10.3039 16.77 10.5882 16.65 10.8235 16.41C11.0588 16.17 11.1765 15.88 11.1765 15.54C11.1765 15.2 11.0588 14.91 10.8235 14.67C10.5882 14.43 10.3039 14.31 9.97059 14.31C9.63725 14.31 9.35294 14.43 9.11765 14.67C8.88235 14.91 8.76471 15.2 8.76471 15.54C8.76471 15.88 8.88235 16.17 9.11765 16.41C9.35294 16.65 9.63725 16.77 9.97059 16.77ZM9.11765 12.96H10.8824C10.8824 12.36 10.9412 11.94 11.0588 11.7C11.1765 11.46 11.549 11.02 12.1765 10.38C12.5294 10.02 12.8235 9.63 13.0588 9.21C13.2941 8.79 13.4118 8.34 13.4118 7.86C13.4118 6.84 13.0735 6.075 12.3971 5.565C11.7206 5.055 10.9216 4.8 10 4.8C9.13725 4.8 8.41177 5.045 7.82353 5.535C7.23529 6.025 6.82353 6.62 6.58824 7.32L8.23529 7.98C8.33333 7.64 8.51961 7.305 8.79412 6.975C9.06863 6.645 9.47059 6.48 10 6.48C10.5294 6.48 10.9265 6.63 11.1912 6.93C11.4559 7.23 11.5882 7.56 11.5882 7.92C11.5882 8.26 11.4902 8.565 11.2941 8.835C11.098 9.105 10.8627 9.38 10.5882 9.66C9.90196 10.26 9.48529 10.735 9.33823 11.085C9.19118 11.435 9.11765 12.06 9.11765 12.96Z"
                fill="#37261D"
              />
            </svg>
          }
        />

        <li className="mt-4">
          <ExternalLink
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                role="graphics-symbol"
              >
                <path
                  d="M11.94 19.2C12.36 19.2 12.715 19.055 13.005 18.765C13.295 18.475 13.44 18.12 13.44 17.7C13.44 17.28 13.295 16.925 13.005 16.635C12.715 16.345 12.36 16.2 11.94 16.2C11.52 16.2 11.165 16.345 10.875 16.635C10.585 16.925 10.44 17.28 10.44 17.7C10.44 18.12 10.585 18.475 10.875 18.765C11.165 19.055 11.52 19.2 11.94 19.2ZM10.86 14.58H13.08C13.08 13.92 13.155 13.4 13.305 13.02C13.455 12.64 13.88 12.12 14.58 11.46C15.1 10.94 15.51 10.445 15.81 9.975C16.11 9.505 16.26 8.94 16.26 8.28C16.26 7.16 15.85 6.3 15.03 5.7C14.21 5.1 13.24 4.8 12.12 4.8C10.98 4.8 10.055 5.1 9.345 5.7C8.635 6.3 8.14 7.02 7.86 7.86L9.84 8.64C9.94 8.28 10.165 7.89 10.515 7.47C10.865 7.05 11.4 6.84 12.12 6.84C12.76 6.84 13.24 7.015 13.56 7.365C13.88 7.715 14.04 8.1 14.04 8.52C14.04 8.92 13.92 9.295 13.68 9.645C13.44 9.995 13.14 10.32 12.78 10.62C11.9 11.4 11.36 11.99 11.16 12.39C10.96 12.79 10.86 13.52 10.86 14.58ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24ZM12 21.6C14.68 21.6 16.95 20.67 18.81 18.81C20.67 16.95 21.6 14.68 21.6 12C21.6 9.32 20.67 7.05 18.81 5.19C16.95 3.33 14.68 2.4 12 2.4C9.32 2.4 7.05 3.33 5.19 5.19C3.33 7.05 2.4 9.32 2.4 12C2.4 14.68 3.33 16.95 5.19 18.81C7.05 20.67 9.32 21.6 12 21.6Z"
                  fill="#37261D"
                />
              </svg>
            }
            url="https://www.hjorteviltregisteret.no/OfteStilteSp%C3%B8rsm%C3%A5l#kategori-Sett%20og%20skutt%20app"
            text={t("pages.hjelpOgKontakt.faq")}
          />
        </li>
        <li>
          <ExternalLink
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="24"
                viewBox="0 0 19 24"
                fill="none"
                role="graphics-symbol"
              >
                <path
                  d="M4.75 19.2H14.25V16.8H4.75V19.2ZM4.75 14.4H14.25V12H4.75V14.4ZM2.375 24C1.72187 24 1.16276 23.765 0.697656 23.295C0.232552 22.825 0 22.26 0 21.6V2.4C0 1.74 0.232552 1.175 0.697656 0.705C1.16276 0.235 1.72187 0 2.375 0H11.875L19 7.2V21.6C19 22.26 18.7674 22.825 18.3023 23.295C17.8372 23.765 17.2781 24 16.625 24H2.375ZM10.6875 8.4V2.4H2.375V21.6H16.625V8.4H10.6875Z"
                  fill="#37261D"
                />
              </svg>
            }
            url="https://www.hjorteviltregisteret.no/OfteStilteSp%C3%B8rsm%C3%A5l#kategori-5"
            text={t("pages.minSide.lenker.dataBruk")}
          />
        </li>
        <li>
          <ExternalLink
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="24"
                viewBox="0 0 19 24"
                fill="none"
                role="graphics-symbol"
              >
                <path
                  d="M9.5 24C6.74896 23.3 4.47786 21.705 2.68672 19.215C0.895573 16.725 0 13.96 0 10.92V3.6L9.5 0L19 3.6V10.92C19 12.62 18.713 14.255 18.1391 15.825C17.5651 17.395 16.7437 18.78 15.675 19.98L11.875 16.14C11.5188 16.36 11.1378 16.525 10.732 16.635C10.3263 16.745 9.91562 16.8 9.5 16.8C8.19375 16.8 7.07552 16.33 6.14531 15.39C5.2151 14.45 4.75 13.32 4.75 12C4.75 10.68 5.2151 9.55 6.14531 8.61C7.07552 7.67 8.19375 7.2 9.5 7.2C10.8062 7.2 11.9245 7.67 12.8547 8.61C13.7849 9.55 14.25 10.68 14.25 12C14.25 12.44 14.1956 12.865 14.0867 13.275C13.9779 13.685 13.8146 14.08 13.5969 14.46L15.3781 16.26C15.774 15.44 16.0807 14.58 16.2984 13.68C16.5161 12.78 16.625 11.86 16.625 10.92V5.25L9.5 2.55L2.375 5.25V10.92C2.375 13.34 3.04792 15.54 4.39375 17.52C5.73958 19.5 7.44167 20.82 9.5 21.48C10.0146 21.32 10.5044 21.115 10.9695 20.865C11.4346 20.615 11.8948 20.32 12.35 19.98L14.0125 21.66C13.3594 22.2 12.6518 22.67 11.8898 23.07C11.1279 23.47 10.3313 23.78 9.5 24ZM9.5 14.4C10.1531 14.4 10.7122 14.165 11.1773 13.695C11.6424 13.225 11.875 12.66 11.875 12C11.875 11.34 11.6424 10.775 11.1773 10.305C10.7122 9.835 10.1531 9.6 9.5 9.6C8.84688 9.6 8.28776 9.835 7.82266 10.305C7.35755 10.775 7.125 11.34 7.125 12C7.125 12.66 7.35755 13.225 7.82266 13.695C8.28776 14.165 8.84688 14.4 9.5 14.4Z"
                  fill="#37261D"
                />
              </svg>
            }
            url={appConfig.urls.personvernerklaering}
            text={t("pages.minSide.lenker.personvern")}
          />
        </li>
        <li>
          <ExternalLink
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="24"
                viewBox="0 0 22 24"
                fill="none"
                role="graphics-symbol"
              >
                <path
                  d="M11 4.8C10.3278 4.8 9.75231 4.565 9.27361 4.095C8.79491 3.625 8.55556 3.06 8.55556 2.4C8.55556 1.74 8.79491 1.175 9.27361 0.705C9.75231 0.235 10.3278 0 11 0C11.6722 0 12.2477 0.235 12.7264 0.705C13.2051 1.175 13.4444 1.74 13.4444 2.4C13.4444 3.06 13.2051 3.625 12.7264 4.095C12.2477 4.565 11.6722 4.8 11 4.8ZM7.33333 24V8.4C6.11111 8.3 4.86852 8.15 3.60556 7.95C2.34259 7.75 1.14074 7.5 0 7.2L0.611111 4.8C2.2 5.22 3.89074 5.525 5.68333 5.715C7.47593 5.905 9.24815 6 11 6C12.7519 6 14.5241 5.905 16.3167 5.715C18.1093 5.525 19.8 5.22 21.3889 4.8L22 7.2C20.8593 7.5 19.6574 7.75 18.3944 7.95C17.1315 8.15 15.8889 8.3 14.6667 8.4V24H12.2222V16.8H9.77778V24H7.33333Z"
                  fill="#37261D"
                />
              </svg>
            }
            url="https://uustatus.no/nb/erklaringer/publisert/5623ef70-67c7-4a59-b611-4e2d73546112"
            text={t("pages.minSide.lenker.tilgjengelighet")}
          />
          <BottomLine />
        </li>
      </ul>
    </div>
  );
};

export default HjelpOgKontakt;
